import { useState } from "react";
import { Button } from "react-bootstrap";
import GoogleFormSubmission from "./Authentication/SignInInput/GoogleForm";

const GoogleForm2 = () => {
  const [option, setOption] = useState(1);
  return (
    <div className="row mx-0" style={{ paddingTop: "20px" }}>
      <div
        className="col-2 d-flex flex-column gap-4"
        style={{ marginTop: "20rem" }}
      >
        <Button variant="primary" onClick={() => setOption(1)}>
          Option 1
        </Button>
        <Button variant="primary" onClick={() => setOption(2)}>
          Option 2
        </Button>
      </div>
      {/* https://docs.google.com/forms/d/e/1FAIpQLSeol9kgUOMw3ixJ504AXBwMuzw3RRw97sCupZsAfDT2BCOS8Q/viewform?usp=pp_url&entry.1972196593=Asad&entry.250102008=123&entry.1136137984=Lookflock&entry.2094370558=1&entry.551383163=A&entry.13428337=2&entry.1772458314=B&entry.1795243579=3&entry.810114298=4&entry.1702128920=C&entry.544141711=D&entry.272270028=5&entry.2094887405=E&entry.1880820514=F&entry.905550485=1&entry.1274506349=G&entry.385608669=2&entry.1913808654=Yes&entry.943723138=H&entry.857860135=I&entry.875854333=3&entry.113140036=4&entry.178412151=J&entry.272533792=K&entry.549016415=5&entry.1419992175=Yes&entry.386049717=No&entry.934701400=Yes&entry.1873773937=No&entry.1758567697=Done */}
      <div className="col-10">
        {option === 1 ? (
          <iframe
            // src="https://docs.google.com/forms/d/e/1FAIpQLSeol9kgUOMw3ixJ504AXBwMuzw3RRw97sCupZsAfDT2BCOS8Q/viewform?embedded=true"
            src="https://docs.google.com/forms/d/e/1FAIpQLSdGY8AhTJeXwz5-9hKrN3L6yAmQJRmHQJyTIrMmZU9tHTmCDg/viewform?embedded=true"
            frameborder="0"
            title="Google Form"
            marginheight="0"
            marginwidth="0"
            style={{
              width: "100%",
              height: "89vh",
            }}
          >
            Loading…
          </iframe>
        ) : (
          <div className="mx-auto" style={{ width: "640px" }}>
            <GoogleFormSubmission />
          </div>
        )}
      </div>
    </div>
  );
};

export default GoogleForm2;
